export default __webpack_public_path__ + "static/media/ORK-CIRCLE.0cea3e81.png";